/**
 * @fileoverview POST handler for the "/ai_agent/openai_responses/:app_group_id" endpoint
 */
import { fetchWithRetry } from "@lib/fetch";

import { serializeAttachedFiles } from "../aiAgentShared";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { aiAgentOpenaiResponsesAppGroupIdCacheKeys } from "./constants";
import type { AiAgentOpenaiResponsesAppGroupIdResult, PostAiAgentOpenaiResponsesAppGroupIdProps } from "./types";

export const postAiAgentOpenaiResponsesAppGroupId = reactQueryMutationAdapter(
  aiAgentOpenaiResponsesAppGroupIdCacheKeys,
  ({
    appGroupId,
    requestId,
    userMessageId,
    sessionId,
    model,
    input,
    mode,
    previousResponseId,
    frontendTools,
    locale,
    browserLocale,
    transport,
    promptSource,
    mockResponseLength,
    dustSessionId,
    attachedFiles,
    delegateKind,
    delegateCallId,
  }: PostAiAgentOpenaiResponsesAppGroupIdProps): Promise<AiAgentOpenaiResponsesAppGroupIdResult> => {
    return fetchWithRetry({ maxAttempts: 3, retryDelay: 1000, expBackoff: true })(
      `/ai_agent/openai_responses/${appGroupId}`,
      "POST",
      {
        model,
        input,
        mode,
        previous_response_id: previousResponseId,
        request_id: requestId,
        user_message_id: userMessageId,
        session_id: sessionId,
        frontend_tools: frontendTools,
        locale,
        browser_locale: browserLocale,
        transport,
        prompt_source: promptSource,
        mock_response_length: mockResponseLength,
        dust_session_id: dustSessionId,
        attached_files: serializeAttachedFiles(attachedFiles),
        ...(delegateKind ? { delegate_kind: delegateKind } : {}),
        ...(delegateCallId ? { delegate_call_id: delegateCallId } : {}),
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
